import { render, staticRenderFns } from "./SkuTable.vue?vue&type=template&id=19e649e0&"
import script from "./SkuTable.vue?vue&type=script&lang=ts&"
export * from "./SkuTable.vue?vue&type=script&lang=ts&"
import style0 from "./SkuTable.vue?vue&type=style&index=0&id=19e649e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports